import { render, staticRenderFns } from "./railwayStation.vue?vue&type=template&id=67061532&"
import script from "./railwayStation.vue?vue&type=script&lang=js&"
export * from "./railwayStation.vue?vue&type=script&lang=js&"
import style0 from "./railwayStation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67061532')) {
      api.createRecord('67061532', component.options)
    } else {
      api.reload('67061532', component.options)
    }
    module.hot.accept("./railwayStation.vue?vue&type=template&id=67061532&", function () {
      api.rerender('67061532', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/railwayStation.vue"
export default component.exports